import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter, ViewEncapsulation, Inject } from '@angular/core';

import { SelectItem, TreeNode } from 'primeng/api';

import * as Highcharts from 'highcharts';
import { chart } from 'highcharts';
import { DateTime } from 'luxon';
import * as _ from 'underscore';

import { GrowlService, WorkflowService, AuthService, CacheService } from '../../../common/service';
import { FailSeriesData } from '../../../common/model';
import { Permission } from '../../../common/enum';
import { catchError, tap } from 'rxjs/operators';
import { NgIf } from '@angular/common';
import { ButtonDirective } from 'primeng/button';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'sensor-fail-chart',
    templateUrl: './sensor-fail-chart.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [NgIf, ButtonDirective]
})
export class SensorFailChartComponent implements OnInit {
  // @ViewChild('masterContainer') masterContainer: ElementRef;
  @ViewChild('detailContainer') detailContainer: ElementRef;
  @Input() sensorFailNumber: number;
  @Input() visible: boolean;
  @Input() showNotNeeded: boolean;
  @Output() closeData: EventEmitter<any> = new EventEmitter();
  Permission = Permission;
  masterChart: any;
  detailChart: any;
  refreshRequired: boolean;
  isLoading: boolean;
  currentChartDataSearchNumber: number;
  fromDate: Date;
  toDate: Date;
  useUTC: boolean = false;
  showPodSelection: boolean;
  showSensorSelection: boolean;
  showTable: boolean;
  podHierarchy: TreeNode[];
  selectedTreeNodes: TreeNode[] = [];
  selectedPodStatus: number[];
  selectedPodNumbers: number[] = [];
  selectedLocationNumbers: number[] = [];
  selectedPodPartNumbers: string[] = [];
  seriesData: FailSeriesData[];
  globalSearch: string;
  filterRecordCount: number;
  tabIndex = 0;

  constructor(
     @Inject(AuthService) public authService: AuthService,
    private workflowService: WorkflowService,
    @Inject(GrowlService) public growlService: GrowlService,
    @Inject(CacheService) public cacheService: CacheService) { }

  ngOnInit() {
    this.cacheService.SetLocal('login-lastChoice', 'workflow/fails');
    this.refreshRequired = true;
    this.isLoading = false;
    this.showTable = false;
  }

  cancel() {
    this.closeData.emit(null);
  }

  drawChart() {
    this.destroyChart();
    this.drawMasterDetailChart();
  }

  refreshChart() {
    if (this.seriesData != null) {
      this.destroyChart();
      // this.drawMasterChart();
      this.drawDetailChart();
    }
  }

  destroyChart() {
    if (this.detailChart != null || this.masterChart != null) {
      this.masterChart.destroy();
      this.masterChart = null;
      this.detailChart.destroy();
      this.detailChart = null;
    }
  }

  drawMasterDetailChart() {
    this.isLoading = true;
    this.workflowService.getSensorFailureData(this.sensorFailNumber).pipe(tap((data) => {
      this.seriesData = data.series;

      // this.drawMasterChart();
      this.drawDetailChart();
      this.refreshRequired = false;
      this.isLoading = false;
    }), catchError((error) => {
      if (error.status === 404) {
        this.growlService.warn('No data found.');
      } else {
        this.growlService.error('An error occured while processing your request. Please try again if the persists please contact your administrator.');
      }
      this.isLoading = false;
      return error;
    })).subscribe();
  }

  drawDetailChart() {
    const seriesOption = this.getSeriesData();

    Highcharts.chart(this.detailContainer.nativeElement, {
      chart: {
        zooming: {
          type: 'x',
        },
      },
      credits: { enabled: false },
      title: { text: '' },
      subtitle: { text: '' },
      xAxis: { type: 'datetime' },
      yAxis: { title: { text: null }, maxRange: 0.1 },
      tooltip: {
        formatter: function (Point: any) {
          let toolTipHtml = '<b>' + DateTime.fromMillis(Number(this.x)).setZone("UTC").toFormat('dd-MMM-yyyy T') + '</b><br/>';
          toolTipHtml += this.series.name + ' | ' + Highcharts.numberFormat(this.y, 2) + '<br/>';
          return toolTipHtml;
        },
        shared: true
      },
      legend: { layout: 'horizontal', align: 'center', verticalAlign: 'top' },
      plotOptions: { series: { marker: { enabled: false, states: { hover: { enabled: true, radius: 3 } } } } },
      series: seriesOption,
      exporting: { enabled: false }
    },
    );
  }

  getSeriesData() {
    const seriesOption = new Array;
    for (let i = 0; i < this.seriesData.length; i++) {
      seriesOption.push({ type: 'line', name: `${this.seriesData[i].podSerialNumber} | ${this.seriesData[i].gas} | ${this.seriesData[i].field}`, pointStart: this.seriesData[i].data[0][0], data: this.seriesData[i].data });
    }
    return seriesOption;
  }

  has(requiredPermissions: Permission | Permission[]) {
    return this.authService.hasPermission(requiredPermissions);
  }
}
